import React, { useMemo } from 'react';
import './InkyPenFooter.scss';
import { Link } from '../../Devon/Components/InkyLink';
import { useLocation } from 'react-router-dom';
import PreFooter from './PreFooter';

const MiddleColumn = (): JSX.Element => {
    return <div className={'middle-links'}>
        <div className={'link-wrappers'}>
            <Link to={'/terms-of-use'} className={'link'} target={'_blank'}>TERMS AND CONDITIONS</Link>
            <Link to={'/privacy'} className={'link'} target={'_blank'}>PRIVACY POLICY</Link>
            <Link to={'/publish'} className={'link'} target={'_blank'}>PUBLISH WITH INKYPEN</Link>
            <Link to={'/press-kit'} className={'link'} target={'_blank'}>PRESS KIT</Link>
        </div>

        <span className='address'>
            © MMXXIV - InkyPen AS, Veiten 3, 5012 Bergen, Norway
        </span>
    </div>;
};

export function InkyPenFooter(): JSX.Element {
    const location = useLocation();
    const isBrowseOrNews = useMemo(() => {
            return location.pathname === '/browse' || location.pathname === '/news';
        }
        , [location]);

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    return (<footer aria-label={'inkypen footer'} className={`InkypenFooter ${isBrowseOrNews && 'paddingForMobile'}`}>
            {/*<div className='go-to-top-link'>*/}
            {/*    <span aria-label={'go to top button'} onClick={() => scrollToTop()} className='go-to-top-link-text'>*/}
            {/*        GO TO TOP*/}
            {/*    </span>*/}
            {/*</div>*/}

            <div className={'margin-top-supporter'}>


            </div>

            <PreFooter />

            <div className={'container'}>
                <div className={'wrapper'}>
                    <div className='about-wrapper'>
                        <span className='about-text'>
                            InkyPen was made possible with the support of
                        </span>
                        <div className='some'>
                            <img alt='Innovation Norway'
                                 className='innovation-logo'
                                 src='https://newdevcdn2.inkypen.co/statics/InnovationNorway_web.png' />
                        </div>
                    </div>

                    <MiddleColumn />

                    {/*<div className='signup-button-wrapper'>*/}
                    {/*    <InkyPenArrow text={'Sign Up'} />*/}
                    {/*</div>*/}

                </div>
            </div>
        </footer>
    );
}
